export default {
	setup: {
		title: "Configurez les enregistrements de votre terreiro",
		optionalTitle: "Enregistrements optionnels",
		progress: "{done} sur {total} enregistrements essentiels",
		optionalProgress: "{done} sur {total} enregistrements optionnels",
		next: "Prochaine étape : {item}",
		open: "Ouvrir",
		assistantHint: "Besoin d'aide ? L'assistant crée les enregistrements avec vous.",
		cta: "Configurer avec l'assistant",
		dismiss: "Ignorer",
		items: {
			medium: "Médiums",
			linha_espiritual: "Lignes Spirituelles",
			guia: "Guides",
			tipo_atendimento: "Types de Consultation",
			tipo_ritual: "Types de Rituel",
			vincular_atendimento: "Associer une consultation au Type de Rituel",
			ritual: "Rituel",
			orixa: "Orixás",
			funcao: "Fonctions",
			etapa_jornada: "Étapes du Parcours",
		},
	},
	greeting: {
		morning: "Bonjour",
		afternoon: "Bon après-midi",
		evening: "Bonsoir",
	},
	activeRitual: {
		title: "Rituel actif",
		noRituals: "Aucun rituel actif",
		noRitualsHint: "Ouvrez un rituel pour commencer à appeler les fiches.",
		viewAll: "Voir les rituels",
		loadError: "Erreur lors du chargement des rituels actifs",
		live: "En direct",
		openSince: "Ouvert à {time}",
		openSinceDate: "Ouvert le {date} à {time}",
		elapsedHours: "il y a {hours}h{minutes}",
		elapsedMinutes: "il y a {minutes} min",
		elapsedDay: "il y a {days} jour",
		elapsedDays: "il y a {days} jours",
		progressLabel: "traitées",
		pending: "En file",
		inProgress: "En cours",
		completed: "Terminées",
		noTickets: "Aucune fiche émise pour l'instant",
	},
	birthdayWidget: {
		title: "Anniversaires",
		noBirthdays: "Aucun anniversaire à venir",
		today: "Aujourd'hui",
		tomorrow: "Demain",
		inDays: "Dans {days} jours",
	},
	kpi: {
		consultants: "Consultants",
		mediums: "Médiums",
		tickets: "Fiches",
	},
	charts: {
		weeklyConsultants: "Nouveaux consultants par semaine",
		monthlyPersons: "Consultants par mois",
		monthlyTickets: "Fiches par mois",
		orixaDistribution: "Enfants par Orixá",
		noData: "Aucune donnée pour cette période",
	},
	topConsultants: {
		title: "Consultants les plus actifs",
		noData: "Aucun consultant avec des fiches",
	},
	upcomingRituals: {
		title: "Prochains événements prévus",
		noRituals: "Aucun rituel prévu",
		viewAll: "Voir tout",
	},
};
